// src/axiosInstance.js
import axios from "axios";

let activeRequests = 0;

const loaderEndpoints = [
  // "/home_navigation_update_acs",
  // "/codebook_acs",
  // "/codebook_acs_v13",
  //  "/index_codebook_acs_v13",
  //  "/index_codebook_acs",
  //  "/AchiCodebookIndex",
  //  "/AchiCodebookIndex_v13",
  //   "/achi_codebook_tabular_v13",
  //   "/achi_codebook_tabular"
  // "get_drg_code_acs",
  //  "/getEpisodeDataAcs",
  // "/Filter_navigation_acs",
  // "/test_reasoning_coding"
]

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

const shouldShowLoader = (url) =>{
    if(!url) return false
    return loaderEndpoints.some((endPoint) =>url.includes(endPoint))
}

// Request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    // Increment active requests count
    if(shouldShowLoader(config.url)){
      activeRequests++;
    window.dispatchEvent(new CustomEvent("loaderStateChange", { detail: { isLoading: true } }));
    }
   

    // Add token
    const token = sessionStorage.getItem("accessToken");
    if (token) {
      config.headers["authorizationToken"] = `${token}`;
    }

    // Append suffix
    const suffix = process.env.REACT_APP_API_SUFFIX || "";
    if (config.url?.startsWith("/")) {
  const [baseUrl, queryParams] = config.url.split("?");
  
  // Split into segments
  const segments = baseUrl.split("/").filter(Boolean);

  if (segments.length > 0) {
    // Add _dev ONLY to the first segment
    segments[0] = segments[0] + suffix;
  }

  // Rebuild URL
  const updatedUrl = "/" + segments.join("/");

  config.url = `${updatedUrl}${queryParams ? `?${queryParams}` : ""}`;
}


    return config;
  },
  (error) => {
    activeRequests = Math.max(activeRequests - 1, 0);
    if (activeRequests === 0) {
      window.dispatchEvent(new CustomEvent("loaderStateChange", { detail: { isLoading: false } }));
    }
    return Promise.reject(error);
  }
);

// Response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    activeRequests = Math.max(activeRequests - 1, 0);
    if (activeRequests === 0) {
      window.dispatchEvent(new CustomEvent("loaderStateChange", { detail: { isLoading: false } }));
    }
    return response;
  },
  (error) => {
    activeRequests = Math.max(activeRequests - 1, 0);
    if (activeRequests === 0) {
      window.dispatchEvent(new CustomEvent("loaderStateChange", { detail: { isLoading: false } }));
    }

    // Token or permission errors
    if (
      error.response &&
      ((error.response.status === 401 && error.response.data.message === "Unauthorized") ||
        error.response.status === 403)
    ) {
      let errorMessage = "";
      if (error.response.status === 401 && error.response.data.message) {
        errorMessage = "Please login again.";
      } else if (error.response.status === 403) {
        errorMessage = "You do not have permission to access this resource.";
      } else if (error.response.status === 401 && error.response.data.permissions) {
        errorMessage = "You do not have permission to access this resource.";
      }

      window.dispatchEvent(new CustomEvent("tokenExpired", { detail: { errorMessage } }));
    } else if (error?.response?.data?.permissions) {
      const errorMessage = error.response.data.permissions;
      window.dispatchEvent(new CustomEvent("tokenExpired", { detail: { errorMessage } }));
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;

